// src/pages/ContactPage.js
import React from 'react';
import { Phone, Mail, MapPin, Clock, Instagram } from 'lucide-react';
import styles from '../css/ContactPage.module.css';

const ContactPage = () => {
  return (
    <section className={styles.contactSection} id="contact">
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.badge}>Bize Ulaşın</span>
          <h2>AKC Motor <span>İletişim</span></h2>
          <p>Motorunuz için en doğru adres. Sorularınız için bir telefon uzağınızdayız.</p>
        </div>

        <div className={styles.contentGrid}>
          {/* İletişim Bilgileri */}
          <div className={styles.infoArea}>
            <div className={styles.infoCard}>
              <MapPin className={styles.icon} />
              <div>
                <h3>Adresimiz</h3>
                <p>Mimar Hayrettin, Arayıcı Sokağı No7/A, 34000 Fatih/İstanbul</p>
              </div>
            </div>

            <div className={styles.infoCard}>
              <Phone className={styles.icon} />
              <div>
                <h3>Telefon</h3>
                <p>0542 642 94 66</p>
              </div>
            </div>

            <div className={styles.infoCard}>
              <Clock className={styles.icon} />
              <div>
                <h3>Çalışma Saatleri</h3>
                <p>Pazartesi - Cumartesi: 09:00 - 20:00 <br/> Pazar: Kapalı</p>
              </div>
            </div>

            <div className={styles.socialArea}>
              <h3>Sosyal Medya</h3>
              <a href="https://instagram.com" target="_blank" rel="noreferrer">
                <Instagram size={30} /> @AKCMOTOR
              </a>
            </div>
          </div>

          {/* Harita Alanı */}
          <div className={styles.mapArea}>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3010.9138845305015!2d28.962422676528714!3d41.005258019610196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab9274fc68a5b%3A0x898c6f2633f269df!2sHuzur%20Motor!5e0!3m2!1str!2str!4v1769293438354!5m2!1str!2str" 
              width="100%" 
              height="100%" 
              style={{ border: 0, borderRadius: '15px' }} 
              allowFullScreen="" 
              loading="lazy"
              title="Akc Moto Konum"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;